// Exportados para que los chips de filtro (desktop y móvil) armen sus opciones
// desde la MISMA paleta que el badge — sin duplicar hex que después driftean.
export const COLORES = {
  borrador:        { bg: '#f1f5f9', color: '#64748b' },
  pendiente_envio: { bg: '#fef3c7', color: '#92400e' },
  enviado:         { bg: '#dbeafe', color: '#1e40af' },
  procesado:       { bg: '#dcfce7', color: '#166534' },
  frenado:         { bg: '#fee2e2', color: '#991b1b' },
}

export const LABELS = {
  borrador:        'Borrador',
  pendiente_envio: 'Pendiente envío',
  enviado:         'Enviado',
  procesado:       'Procesado',
  frenado:         'Frenado',
}

export default function EstadoBadge({ estado }) {
  const style = COLORES[estado] || { bg: '#f1f5f9', color: '#64748b' }
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      background: style.bg,
      color: style.color,
    }}>
      {LABELS[estado] || estado}
    </span>
  )
}
